/**
 * @file pxToRem
 * @author ivyyypan(ivyyypan@tencent.com)
 */
export function pxToRem(size) {
    // http://git.code.oa.com/sns_marketing_front/docs/blob/master/业务文档/落地页项目/技术方案/原生落地页/原生落地页尺寸说明.md
    return Number((size / 37.5).toFixed(4));
}
